import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { useScripts } from '../use-scripts';

export function ScriptProvider({
  children,
  urls,
  domainList
}: {
  children: ReactElement;
  urls: string[];
  domainList: string[];
}) {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  const handleScriptsLoaded = useCallback(() => setScriptsLoaded(true), []);

  useEffect(() => {
    window.awsWafCookieDomainList = domainList;
  }, [domainList]);

  useScripts({ urls, onScriptsLoaded: handleScriptsLoaded });
  return <>{scriptsLoaded ? children : null}</>;
}
